import React, { memo } from 'react'

import { FileTextShield, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import DesktopOnlyTooltip from 'Pods/Shared/DesktopOnlyTooltip/DesktopOnlyTooltip'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import { AI_TERMS_OF_SERVICE_HREF, iconSizeNav } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function TermsOfServiceButton() {
  const t = useTranslation()
  const { isCurrentUser: isLoggedIn } = usePageConfig() || {}
  const label = t('sidebar.termsOfService.label')

  if (!isLoggedIn) {
    return null
  }

  return (
    <DesktopOnlyTooltip
      content={label}
      id="terms-of-service-button-tooltip"
      place="top"
      containerClass="terms-of-service-button-tooltip"
      className="terms-of-service-button-tooltip__trigger"
    >
      <a
        href={AI_TERMS_OF_SERVICE_HREF}
        target="_blank"
        rel="noopener noreferrer"
        className="terms-of-service-button"
        aria-label={label}
      >
        <Icon svgComponent={FileTextShield} color="darker" size={iconSizeNav} notSpaced />
      </a>
    </DesktopOnlyTooltip>
  )
}

export default memo(TermsOfServiceButton)
